import { render, staticRenderFns } from "./contact-support.vue?vue&type=template&id=319aad0f"
import script from "./contact-support.vue?vue&type=script&lang=js"
export * from "./contact-support.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports